import gql from 'graphql-tag';

export default gql`
query getAllAccountsForAdmin {
  groups {
    group_id
    parent_group_id
    name
    slug
    domain
    group_path
    settings
    created_at
    pages_aggregate {
      aggregate {
        count
        max {
          updated_at
          published_at
        }
      }
    }
    projects_aggregate {
      aggregate { count }
    }
  }
}
`;
